export const pageVisibleState = (_config, data) => {
  return {
    'pageVisible:state': data.pageVisibleState
  };
};